import { Action, createReducer, on } from '@ngrx/store';
import { Tab } from '../../modules/main/enums/tab.enum';
import * as TabActions from '../actions/tab.actions';

export interface TabState {
  tab: Tab | undefined;
}

export const initialState: TabState = {
  tab: undefined,
};

export const tabReducer = createReducer<TabState>(
  initialState,
  on(TabActions.setActiveTabAction, (state: TabState, { payload: { tab } }: { payload: { tab: Tab } }) => {
    return {
      ...state,
      tab,
    };
  })
);

export function TabReducer(state: TabState | undefined, action: Action): TabState {
  return tabReducer(state, action);
}

export const getTab = (state: TabState) => state.tab;
